import { useTranslation } from "react-i18next";
import { MyLeaveLeaveCardProps } from "./leave-card";

interface UseMyLeaveLeaveCardProps
  extends Omit<MyLeaveLeaveCardProps, "useMyLeaveLeaveCard"> {}

const titles: Record<MyLeaveLeaveCardProps["type"], string> = {
  base: "MY_LEAVE_NEW_LEAVE_BASE",
  study: "MY_LEAVE_LEAVE_STUDY",
  covid: "MY_LEAVE_COVID_PLUS_10",
  eszjtv: "MY_LEAVE_LEAVE_ESZJTV",
  emergency: "MY_LEAVE_LEAVE_EMERGENCY",
} as const;

export const useMyLeaveLeaveCard = ({
  type,
  fulfilled,
  requestable,
  requested,
}: UseMyLeaveLeaveCardProps) => {
  const { t } = useTranslation();
  const allDays = fulfilled + requestable + requested;

  const formattedAllDays = allDays.toString().replace(".", ",");

  const title = `${t(titles[type])} (${formattedAllDays})`;

  return {
    title,
  };
};
